(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variants-container"] && !Shopify.designMode) return;
  try {
    (function() {
        const elements = document.querySelectorAll('.offer__element--selectable');

        function setQuantity(qty) {
            // Finder quantity input — understøtter både standard og cart-varianter
            const input = document.querySelector('input[name="quantity"], input[name="updates[]"]');
            if (!input) return;

            input.value = qty;

            // Trigger change/input events så Shopify's egne komponenter reagerer
            input.dispatchEvent(new Event('change', { bubbles: true }));
            input.dispatchEvent(new Event('input', { bubbles: true }));
        }

        elements.forEach(el => {
            el.addEventListener('click', function() {
                // Fjern aktiv klasse fra alle
                elements.forEach(e => e.classList.remove('offer__element--active'));
                // Sæt aktiv klasse på det valgte
                this.classList.add('offer__element--active');

                const qty = parseInt(this.dataset.quantity, 10);
                setQuantity(qty);
            });
        });

        const defaultQty = document.querySelector('.offer__container')?.dataset.defaultQuantity;
        const defaultEl = document.querySelector(`.offer__element--selectable[data-quantity="${defaultQty}"]`);
        if (defaultEl) defaultEl.click();
    })();
  } catch(e) { console.error(e); }
})();

})();
